//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link, NavLink } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'
import { AuthContext } from '../context/auth-context'
import SearchByTeam from '../components/UIElements/SearchByTeam'
import SearchByLeagueOrVenue from '../components/UIElements/SearchByLeagueOrVenue'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import Banner from '../../shared/components/Navigation/Banner'
//import FilterByTeam from '../components/UIElements/FilterByTeam'
import Arsenal from '../../images/Arsenal.png'
import BarrieKingsmen from '../../images/Barrie-kingsmen.png'
import ChicagoSouthsiders from '../../images/Chicago Southsiders.png'
import Dekheads from '../../images/Dekheads.png'
import Gods from '../../images/Gods.png'
import Graffix from '../../images/Graffix.png'
import Indians from '../../images/Indians.png'
import MidnightExpress from '../../images/Midnight Express.png'
import NightsWatch from '../../images/Nights Watch.png'
import NorthsideMilitia from '../../images/Northside Militia.png'
import PurplePower from '../../images/Purple Power.png'
import RoseCityRoyals from '../../images/Rose City Royals.png'
import Warriors from '../../images/Warriors.png'
import USA from '../../images/USA-logo.png'
import JrGods from '../../images/Team Pittsburgh Jr. Gods.png'
import Raptors from '../../images/Riverview Raptors.jpeg'
import Americans from '../../images/Americans.png'
import { FaUsers } from 'react-icons/fa'

const TeamSchedule = () => {
	console.log('inside TeamSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	//const [teamId, setTeamId] = useState()
	const [leagueId, setLeagueId] = useState()
	const [wins, setWins] = useState()
	const [losses, setLosses] = useState()
	const [overtimeLosses, setOvertimeLosses] = useState()
	const [shootoutLosses, setShootoutLosses] = useState()
	const [ties, setTies] = useState()
	const [allTeamGames, setAllTeamGames] = useState([])
	const [divisionName, setDivisionName] = useState()
	const [leagueName, setLeagueName] = useState()
	const [teamName, setTeamName] = useState()
	const [allPotentialPlayoffGames, setAllPotentialPlayoffGames] = useState()
	//
	const auth = useContext(AuthContext)

	const teamLogoMap = {
		'Penn Hills Arsenal': Arsenal,
		'Barrie Kingsmen': BarrieKingsmen,
		'Chicago Southsiders': ChicagoSouthsiders,
		'Iowa Dekheads': Dekheads,
		'Pittsburgh Gods': Gods,
		'Graffix Ball Hockey Club': Graffix,
		'Garden State Indians': Indians,
		'Brampton Midnight Express': MidnightExpress,
		"South Jersey Night's Watch": NightsWatch,
		'South Jersey Night’s Watch': NightsWatch,
		'Northside Militia': NorthsideMilitia,
		'Pittsburgh Purple Power': PurplePower,
		'Rose City Royals': RoseCityRoyals,
		'Garden State Warriors': Warriors,
		'USA Legends': USA,
		'Leominster Americans': Americans,
		'Pittsburgh Jr. Gods': JrGods,
		'Riverview Raptors': Raptors,
	}

	const teamLogo = teamLogoMap[teamName]

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])
	//
	//MATT:  I sent over other params as well (from FilterByTeam), but it looks like o only need teamId
	//
	const teamId = useParams().teamId
	console.log('useParams: ' + useParams())

	//Get all games for a team.  getTeamSchedule2.  Also returns teamId.
	useEffect(() => {
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			setAllTeamGames([])
			try {
				const response = await fetch(
					//`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${leagueName}/${divisionName}/${year}/${teamName}`
					`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${teamId}`,
				)

				const responseData = await response.json()

				//console.log('responseData: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllTeamGames(responseData.allTeamGamesArray)
				setAllPotentialPlayoffGames(responseData.allPotentialPlayoffGamesArray)
				//setTeamId(responseData.teamId)
				setTeamName(responseData.teamName)
				setWins(responseData.wins)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setLeagueId(responseData.leagueId)
				setDivisionName(responseData.divisionName)
				setLeagueName(responseData.leagueName)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [teamId])
	//
	//
	allTeamGames && console.log('allTeamGames: ' + JSON.stringify(allTeamGames))
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	let rem

	if (allTeamGames) {
		//console.log('assignedPlayers: ' + assignedPlayers)
		if (allTeamGames.length > 10) {
			rem = '2rem'
		} else {
			rem = '20rem'
		}
	}
	//
	//
	const getBaseDivision = (divisionName = '') => {
		return divisionName.replace(/\s+East$/i, '').replace(/\s+West$/i, '')
	}
	//
	//
	//
	const getTeamLogo = (teamName) => teamLogoMap[teamName]

	const getDisplayScore = (game) => {
		if (!game.score) return ''
		return `${game.score}${game.scoreSuffix ? ` ${game.scoreSuffix}` : ''}`
	}

	const getFormattedDate = (game) => {
		const month = game.date.substr(0, 2)
		const day = game.date.substr(3, 2)

		const monthMap = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${monthMap[month]} ${day}`
	}

	const getFormattedTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minutes = game.time.substr(3, 2)

		const hourMap = {
			'00': '12',
			'01': '1',
			'02': '2',
			'03': '3',
			'04': '4',
			'05': '5',
			'06': '6',
			'07': '7',
			'08': '8',
			'09': '9',
			10: '10',
			11: '11',
			12: '12',
			13: '1',
			14: '2',
			15: '3',
			16: '4',
			17: '5',
			18: '6',
			19: '7',
			20: '8',
			21: '9',
			22: '10',
			23: '11',
			24: '12',
		}

		const suffix = Number(hour) < 12 || hour === '24' ? 'AM' : 'PM'

		return `${hourMap[hour]}:${minutes} ${suffix}`
	}

	const getWinningTeamClass = (game, team) => {
		if (!game.score) return ''

		const isWinner =
			(team === 'home' && game.winner === game.homeTeamId) ||
			(team === 'visitor' && game.winner === game.visitorTeamId)

		if (!isWinner) return ''

		const isPlayoff = game.playoff || game.championship || game.description

		return isPlayoff
			? 'mobileWinningTeam mobileWinningTeamPlayoff'
			: 'mobileWinningTeam'
	}

	const renderMobileScheduleCards = (games = []) => {
		return (
			<div className='mobileGameCards'>
				{games.map((game, key) => {
					const homeLogo = getTeamLogo(game.homeTeamName)
					const visitorLogo = getTeamLogo(game.visitorTeamName)
					const divisionLabel = game.playoff
						? game.playoffDivision
						: game.divisionName

					return (
						<div
							className={`mobileGameCard ${
								game.playoff || game.championship || game.description
									? 'mobileGameCardPlayoff'
									: ''
							}`}
							key={key}
						>
							<div className='mobileGameCardHeader'>
								<div>{getFormattedDate(game)}</div>

								<div className='mobileGameDivisionHeader'>
									<span>{divisionLabel}</span>
									{game.description && (
										<span className='mobileGameDescription'>
											{game.description}
										</span>
									)}
								</div>

								<div>{getFormattedTime(game)}</div>
							</div>

							<div className='mobileGameCardBody'>
								<div className='mobileGameTeam'>
									{homeLogo && <img src={homeLogo} alt={game.homeTeamName} />}
									<div className={getWinningTeamClass(game, 'home')}>
										{game.homeTeamAbbreviation || game.homeTeamName}
									</div>
								</div>

								{game.score ? (
									<Link
										className='mobileGameScore'
										to={`/gameSummary/${game._id}`}
									>
										{getDisplayScore(game)}
										<span>Final</span>
									</Link>
								) : (
									<div className='mobileGameScore mobileGameScoreEmpty'>
										<span>TBP</span>
									</div>
								)}

								<div className='mobileGameTeam'>
									{visitorLogo && (
										<img src={visitorLogo} alt={game.visitorTeamName} />
									)}
									<div className={getWinningTeamClass(game, 'visitor')}>
										{game.visitorTeamAbbreviation || game.visitorTeamName}
									</div>
								</div>
							</div>

							<div className='mobileGameVenue'>📍 {game.venueName}</div>
						</div>
					)
				})}
			</div>
		)
	}
	//
	//
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && allTeamGames.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />
				<div style={{ marginTop: '5rem' }}>
					{/* <SearchByTeam /> */}
					<SearchByLeagueOrVenue />
				</div>
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (!isLoading && allTeamGames.length !== 0) {
		dateBlock.push(
			<React.Fragment>
				<div className='Schedule'>
					{/* <SearchByTeam /> */}
					<SearchByLeagueOrVenue />
					<div className='teamScheduleDesktopHeader'>
						<h1>{teamName}</h1>
						<h3 className='h3Center'>
							{allTeamGames[0].year + ' ' + allTeamGames[0].leagueName}
						</h3>
						<h3 className='h3Center'>
							{allTeamGames[0].divisionName + ' Division '}
						</h3>
						<h3 className='h3Center'>
							Record: {wins} - {losses} -{' '}
							{ties + shootoutLosses + overtimeLosses}
						</h3>
					</div>

					<div className='clubsTeamScheduleMobileHero'>
						{teamLogo ? (
							<img
								src={teamLogo}
								alt={`${teamName} logo`}
								className='clubsHeroTeamLogo'
							/>
						) : (
							<div className='clubsHeroLogoCircle'>
								<FaUsers />
							</div>
						)}

						<h1>{teamName}</h1>

						<div className='clubsHeroLeaguePill'>
							{allTeamGames[0].year + ' ' + allTeamGames[0].leagueName}
						</div>

						<div className='clubsHeroDivision'>
							{allTeamGames[0].divisionName} Division
						</div>

						<div className='clubsHeroDivider'></div>

						<div className='clubsHeroRecordLabel'>Record</div>

						<div className='clubsHeroRecordCard'>
							<div className='clubsHeroRecordGrid'>
								<div>
									<strong>{wins}</strong>
									<span>Wins</span>
								</div>

								<div className='clubsHeroRecordDash'>-</div>

								<div>
									<strong>{losses}</strong>
									<span>Losses</span>
								</div>

								<div className='clubsHeroRecordDash'>-</div>

								<div>
									<strong>{ties + shootoutLosses + overtimeLosses}</strong>
									<span>Ties</span>
								</div>
							</div>
						</div>
					</div>
					<p className='clickOn'>
						(Click on the final score of a game to see a Game Summary)
					</p>
					{isMobile ? (
						renderMobileScheduleCards(allTeamGames)
					) : (
						<table id='teamScheduleDisplay'>
							<thead>
								<tr>
									<th>Date/Time</th>
									<th>Opponent</th>
									<th>Score</th>
									<th>Pts</th>
								</tr>
							</thead>
							<tbody>
								{allTeamGames.map((game, key) => {
									// if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												{/* </td>
									<td> */}
												{', '}
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am '}
												{/* </td>
									<td> */}
												<br></br>
												{game.venueName}
											</td>
											{/* <td>
										{(game.status && game.status !== 'TBP' && (
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												{game.status}
											</Link>
										)) ||
											'TBP'}
									</td> */}

											{game.homeTeamName === teamName && (
												<td>
													{game.visitorTeamName} <br></br>
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}
											{game.visitorTeamName === teamName && (
												<td>
													@ {game.homeTeamName}
													<br></br>
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}
											{!game.score && <td></td>}
											{game.score && !game.winner && !game.loser && (
												<td style={{ color: 'black', fontWeight: 'bold' }}>
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														TIED {game.score}
													</Link>
												</td>
											)}
											{game.loser === teamId && (
												<td style={{ color: 'red', fontWeight: 'bold' }}>
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'red',
														}}
														to={`/gameSummary/${game._id}`}
													>
														LOST {game.score}
														<span
															style={{ color: 'black', fontWeight: 'bold' }}
														>
															{game.scoreSuffix}
														</span>
													</Link>
												</td>
											)}
											{game.winner === teamId && (
												<td style={{ color: 'green', fontWeight: 'bold' }}>
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'green',
														}}
														to={`/gameSummary/${game._id}`}
													>
														WON {game.score}
														<span
															style={{ color: 'black', fontWeight: 'bold' }}
														>
															{game.scoreSuffix}
														</span>
													</Link>
												</td>
											)}
											<td style={{ fontWeight: 'bold' }}>
												{game.score &&
													game.homeTeamName === teamName &&
													game.homePointsAwarded}
												{game.score &&
													game.visitorTeamName === teamName &&
													game.visitorPointsAwarded}
											</td>
										</tr>
									)
									//}
								})}
							</tbody>
						</table>
					)}
				</div>
				<div className='Schedule' style={{ marginTop: '7rem' }}>
					<h3 className='clubsMobileScheduleSectionTitle'>
						<span>{getBaseDivision(divisionName)} Playoff Games</span>
					</h3>
					{isMobile ? (
						renderMobileScheduleCards(allPotentialPlayoffGames)
					) : (
						<table id='teamScheduleDisplay'>
							<thead>
								<tr>
									<th>Date/Time</th>
									<th>Visitor/Home</th>
									{auth.isLoggedIn && <th></th>}
									<th>Winner</th>
									<th>Score</th>
								</tr>
							</thead>
							<tbody>
								{allPotentialPlayoffGames.map((game, key) => {
									// if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												{', '}
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am '}
												<br></br> {game.venueName}
											</td>
											{/* //
										//
										//    Visitor/Home
										//
										// */}
											{game.visitorTeamName && !isMobile && (
												<td>
													{game.visitorTeamSeed > 0 &&
														'(' + game.visitorTeamSeed + ') '}
													{game.visitorTeamName && game.visitorTeamName}
													<br></br>
													{' @ '}
													<br></br>
													{game.homeTeamSeed > 0 &&
														'(' + game.homeTeamSeed + ') '}
													{game.homeTeamName && game.homeTeamName}
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}
											{/* //
										//
										//
										// */}
											{game.visitorTeamName && isMobile && (
												<td>
													{game.visitorTeamSeed > 0 &&
														'(' + game.visitorTeamSeed + ') '}
													{game.visitorTeamAbbreviation || game.visitorTeamName}
													<br></br>
													{' @ '}
													<br></br>
													{game.homeTeamSeed > 0 &&
														'(' + game.homeTeamSeed + ') '}
													{game.homeTeamAbbreviation || game.homeTeamName}
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}
											{/* //
										//
										//
										// */}
											{auth.isLoggedIn && (
												<td>
													{game.playoff &&
														!game.championship &&
														game.homeTeamName &&
														(game.homeTeamName === 'TBD' ||
															game.visitorTeamName === 'TBD') && (
															<NavLink
																className='navlinksEnterTeams'
																to={`/admin/updateGame/${game._id}`}
																exact
															>
																TEAMS
															</NavLink>
														)}
												</td>
											)}
											{/* //
										//
										//    Winner
										//
										// */}
											{!isMobile &&
												game.homeTeamId &&
												game.winner === game.homeTeamId && (
													<td>{game.homeTeamName}</td>
												)}
											{!isMobile &&
												game.visitorTeamId &&
												game.winner === game.visitorTeamId && (
													<td>{game.visitorTeamName}</td>
												)}
											{isMobile &&
												game.homeTeamId &&
												game.winner === game.homeTeamId && (
													<td>
														{game.homeTeamAbbreviation || game.homeTeamName}
													</td>
												)}
											{isMobile &&
												game.visitorTeamId &&
												game.winner === game.visitorTeamId && (
													<td>
														{game.visitorTeamAbbreviation ||
															game.visitorTeamName}
													</td>
												)}
											{/* //
										//
										//    Status
										//
										// */}
											{game.status &&
												game.status !== 'TBP' &&
												game.winner !== game.homeTeamId &&
												game.winner !== game.visitorTeamId && <td>TIE</td>}
											{!game.score && <td></td>}
											{/* //
										//
										//    Score
										//
										// */}
											<td
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
											>
												<Link
													style={{
														color: 'black',
														fontWeight: 'bold',
														textDecoration: 'none',
													}}
													to={`/gameSummary/${game._id}`}
												>
													{game.score}
													<span style={{ color: 'black', fontWeight: 'bold' }}>
														{game.scoreSuffix}
													</span>
												</Link>
											</td>
										</tr>
									)
									//}
								})}
							</tbody>
						</table>
					)}
				</div>
			</React.Fragment>,
		)
		// }
		//)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation />
				{!isMobile && (
					<div style={{ marginTop: '5rem' }}>
						<Banner />
					</div>
				)}
				{dateBlock && dateBlock}
				<div>
					<Footer />
				</div>
			</React.Fragment>
		</div>
	)
}

export default TeamSchedule
